module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_type_dress@3x-e8126f600f0f1da439ef7f92036f1579.webp";